trustpilot_lazy_load = ->
  if el = document.querySelector('.trustpilot-widget.lazy-load')
    el.classList.remove 'lazy-load'
    loaded = true
    script = document.createElement('SCRIPT')
    script.setAttribute('async', 'true')
    script.setAttribute('src', "//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js")
    el.append script

document.addEventListener "DOMContentLoaded", trustpilot_lazy_load